import { ModelTask } from './enums.js';
/** Cible dérivée d'images annotées pour la détection : un plancher, relevé par le nombre de classes. */
function detectionTarget(targetCount) {
    return Math.max(150, 150 * targetCount);
}
function derive(ids, locked, done) {
    const resumeStepId = ids.find((id) => !locked(id) && !done(id)) ?? null;
    const steps = ids.map((id) => {
        const state = locked(id)
            ? 'locked'
            : done(id)
                ? 'done'
                : id === resumeStepId
                    ? 'current'
                    : 'todo';
        return { id, state };
    });
    return { steps, resumeStepId };
}
function detectionPlan(objective, signals) {
    const target = detectionTarget(objective.targets.length);
    const datasetDone = signals.annotatedCount >= target;
    const baseModelDone = signals.readyModelCount > 0;
    const evaluateDone = signals.evaluatedModelCount > 0;
    const ids = ['dataset', 'base-model', 'train', 'evaluate', 'deploy', 'analyze'];
    const isLocked = (id) => id === 'train' || id === 'deploy' || id === 'analyze';
    const isDone = (id) => (id === 'dataset' && datasetDone) ||
        (id === 'base-model' && baseModelDone) ||
        (id === 'evaluate' && evaluateDone);
    const { steps, resumeStepId } = derive(ids, isLocked, isDone);
    // Si aucune donnée en main, on pousse l'annotation ; sinon la réutilisation de l'existant.
    // `recommended` est **omis** (et non `false`) quand la branche ne l'est pas — sémantique optionnelle.
    const recommendedDatasetBranch = objective.dataOnHand !== 'NONE' ? 'reuse' : 'annotate';
    const datasetBranch = (id) => id === recommendedDatasetBranch ? { id, recommended: true } : { id };
    const enrich = {
        dataset: {
            meter: { have: signals.annotatedCount, target, unit: 'images annotées' },
            branches: ['annotate', 'reuse', 'clean', 'simulate', 'field'].map(datasetBranch),
        },
        'base-model': {
            branches: [{ id: 'adopt', recommended: true }, { id: 'import' }],
        },
    };
    return {
        task: objective.task,
        steps: steps.map((step) => ({ ...step, ...(enrich[step.id] ?? {}) })),
        resumeStepId,
    };
}
/** Plan « à venir » pour une tâche réservée (non implémentée) : une seule étape verrouillée. */
function reservedPlan(task) {
    return { task, steps: [{ id: 'coming-soon', state: 'locked' }], resumeStepId: null };
}
export function deriveObjectivePlan(objective, signals) {
    return objective.task === ModelTask.DETECTION
        ? detectionPlan(objective, signals)
        : reservedPlan(objective.task);
}
//# sourceMappingURL=objective-plan.js.map